export const MAPS_API_KEY = "AIzaSyDnK9zT-8E_zroelryDJmQ_Gb6xkORYaxc";

export const DEFAULT_SW_LAT = 33.59173981141882;
export const DEFAULT_SW_LNG = -112.71925540675291;
export const DEFAULT_NE_LAT = 33.60823808684144;
export const DEFAULT_NE_LNG = -112.68595794096298;

export const DEFAULT_ZOOM_LEVEL = 18;

export interface InitialiseMapOptions {
	apiKey: string;
	mapId: string;
	container: HTMLElement;
	center?: google.maps.LatLngLiteral;
	zoomControl?: boolean;
	zoom?: number;
	minZoom?: number;
	maxZoom: number;

	styles?: google.maps.MapTypeStyle[];
}

export interface LotApiResponse {
	type: string;
	data: {
		lot: {
			id: number;
			number: number;
			name: string;
			description: string;
			src: string;
			url: string;
			slug: string;
			status: string;
			model: boolean;
			modeled: boolean;
			tour: string;
		};
		plan: {
			id: number;
			name: string;
			description: string;
			url: string;
			slug: string;
			beds: string;
			baths: string;
			stories: string;
			garages: string;
			sq_ft: string;
			price: string;
		};
		collection: {
			id: number;
			name: string;
			url: string;
			slug: string;
			email: string;
			phone: string;
			address: string;
		};
		builder: {
			id: number;
			name: string;
			url: string;
			slug: string;
		};
	};
	properties: any;
	geometry: {
		type: string;
		coordinates: number[][];
	};
}
